import(/* webpackMode: "eager" */ "D:\\Aarav\\Projects\\relaxing-routine\\app\\terms\\page.tsx");
